<template>
    <div class="component-sub-navbar">
        <b-navbar class="sub-navbar">

            <b-navbar-nav class="mx-auto" v-if="parent === 'budget'"> <!-- ml-auto forces items to be center aligned -->
                <b-nav-item :active="'tasks' === $route.name.split('-')[1]" :to="{name: 'budget-tasks'}">Tasks<el-badge :value="tasksOpen" :max="100" type="primary" class="item"></el-badge></b-nav-item>
                <b-nav-item :active="'budget' === $route.name.split('-')[1]" :to="{name: 'budget-budget', query: this.$route.query}">Budget</b-nav-item>
                <b-nav-item :active="'graph' === $route.name.split('-')[1]" :to="{name: 'budget-graph'}">Dashboard</b-nav-item>
                <b-nav-item :active="'analytics' === $route.name.split('-')[1]" :to="{name: 'budget-analytics'}">Analytics</b-nav-item>
            </b-navbar-nav>

            <b-navbar-nav class="mx-auto" v-if="parent === 'performance'"> <!-- ml-auto forces items to be center aligned -->
                <!-- <b-nav-item :active="'tasks' === $route.name.split('-')[1]" :to="{name: 'performance-tasks'}">Tasks<el-badge :value="$store.state[this.$props.parent].ticketsOpen" :max="100" type="primary" class="item"></el-badge></b-nav-item> -->
                <b-nav-item :active="'workforce' === $route.name.split('-')[1]" :to="{name: 'performance-workforce'}">Workforce</b-nav-item>
                <b-nav-item :active="'contracts' === $route.name.split('-')[1]" :to="{name: 'performance-contracts'}">Contracts</b-nav-item>
                <b-nav-item :active="'productivity' === $route.name.split('-')[1]" :to="{name: 'performance-productivity'}">Productivity</b-nav-item>
                <b-nav-item :active="'powerhours' === $route.name.split('-')[1]" :to="{name: 'performance-powerhours'}">Power hours</b-nav-item>
            </b-navbar-nav>

            <b-navbar-nav class="mx-auto" v-if="parent === 'cost'"> <!-- ml-auto forces items to be center aligned -->
                <!-- <b-nav-item :active="'tasks' === $route.name.split('-')[1]" :to="{name: 'performance-tasks'}">Tasks<el-badge :value="$store.state[this.$props.parent].ticketsOpen" :max="100" type="primary" class="item"></el-badge></b-nav-item> -->
                <b-nav-item :active="'analytics' === $route.name.split('-')[1]" :to="{name: 'cost-analytics'}">Analytics</b-nav-item>
                <b-nav-item :active="'hours' === $route.name.split('-')[1]" :to="{name: 'cost-hours-split'}">Hours split</b-nav-item>
            </b-navbar-nav>

            <!-- eslint-disable-next-line -->
            </router-view>
        </b-navbar>
    </div>
</template>

<script>
import axios from '@/services/axios.js'
import vue from 'vue'
import { getHeadersWithAccessToken } from '../functions'
export default {
    name: 'sub-navbar',
    props: ['parent'],
    data () {
        return {
        }
    },
    computed: {
        tasksOpen () {
            return this.$store.state[this.$props.parent].ticketsOpen
        }
    },
    watch: {
        '$route.query' () {
            axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_TICKET_API_BASE_URL_DEV : process.env.VUE_APP_TICKET_API_BASE_URL) + '/user_tickets?module=' + this.$props.parent, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    let open = []
                    for (let item of response.data.data) {
                        if (item.modified === false) {
                            open.push(item)
                        }
                    }
                    vue.set(this.$store.state[this.$props.parent], 'ticketsOpen', open.length)
                })
                .catch(error => {
                    console.log(error)
                })
        }
    },
    created () {
        if (this.$store.state[this.$props.parent].ticketsOpen === undefined) {
            axios.get(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_TICKET_API_BASE_URL_DEV : process.env.VUE_APP_TICKET_API_BASE_URL) + '/user_tickets?module=' + this.$props.parent, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    let open = []
                    for (let item of response.data.data) {
                        if (item.modified === false) {
                            open.push(item)
                        }
                    }
                    vue.set(this.$store.state[this.$props.parent], 'ticketsOpen', open.length)
                })
                .catch(error => {
                    console.log(error)
                })
        }
    }
}
</script>

<style lang="scss">
.component-sub-navbar {
    margin-bottom: 50px;
    .sub-navbar {
        padding-right: 60px;
        background-color: #fff;
    }
    @media(max-width: 768px) {
        .sub-navbar {
            padding-right: 0px;
        }
    }
    a.nav-link {
        padding: 8px 25px !important;
        font-size: 16px !important;
    }
    .active {
        border-bottom: 2px solid #0C447A;
    }
    .navbar {
        padding-bottom: 0;
    }
    .el-badge__content--primary {
        background-color: #0C447A;
    }
    @media(max-width: 768px) {
        a.nav-link {
            padding: 8px !important;
            font-size: 14px !important;
        }
    }
}
</style>
